import React from "react";

/*
CategoryCrossfilterContext is used to pass a snapshot of the crossfilter 
matching the current category summary.
*/
export const CategoryCrossfilterContext = React.createContext(null);
